import React from 'react';
import { Heart, MapPin } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-5 gap-10 md:gap-14 items-center">
          {/* Decorative side */}
          <div className="md:col-span-2">
            <div className="relative aspect-square rounded-3xl overflow-hidden shadow-xl shadow-pink-100 border border-pink-100">
              <div className="absolute inset-0 bg-gradient-to-br from-pink-100 via-rose-50 to-pink-200" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-40 h-40 rounded-full bg-white shadow-xl flex items-center justify-center">
                  <Heart className="h-16 w-16 text-pink-500 fill-pink-500" />
                </div>
              </div>
              <div className="absolute top-6 left-6 w-6 h-6 rounded-full bg-pink-400/60" />
              <div className="absolute bottom-8 right-8 w-10 h-10 rounded-full bg-rose-400/50" />
              <div className="absolute top-1/3 right-6 w-4 h-4 rounded-full bg-pink-500/70" />
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="inline-flex items-center gap-2 bg-pink-50 border border-pink-200 text-pink-600 rounded-full px-3 py-1 text-xs font-semibold tracking-wider mb-4">
              <MapPin className="h-3.5 w-3.5" /> ABOUT THE STUDIO
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
              About <span className="gradient-text">S Pink Nails</span>
            </h2>
            <p className="mt-6 text-gray-600 text-lg leading-relaxed">
              Welcome to S Pink Nails, your premier destination for professional nail care. As a
              skilled and passionate nail technician, I pride myself on delivering exceptional
              service with meticulous attention to detail.
            </p>
            <p className="mt-4 text-gray-600 text-lg leading-relaxed">
              My in-studio space provides a clean, professional, and welcoming environment where you
              can relax and enjoy a luxurious nail experience. Whether you&apos;re looking for classic
              elegance or creative nail art, I&apos;m dedicated to bringing your vision to life with
              high-quality products and expert craftsmanship.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
